export enum Roles {
  ADMIN= 'servreg_admin',
  USER = 'webportal_user'
}
